import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent implements OnInit {
  message: string;
  /* updateImage from  an video*/ 
  videoElement : HTMLVideoElement;
  isCanvasShown :boolean = false;
  constructor(private dialogRef: MatDialogRef<AlertDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = data.message;
    /* updateImage from  an video*/
    this.videoElement = data.videoElement && (data.videoElement != null || data.videoElement != undefined || data.videoElement != '') ? data.videoElement : '';
    this.isCanvasShown = data.canvas && data.canvas === true ? true : false;
  }

  ngOnInit(): void {
    /* updateImage from  an video*/
    const canvasElement = document.getElementById('myCanvas') as HTMLCanvasElement;
    const context = canvasElement.getContext('2d');
    if (!context) {
      console.error('2D context is not supported in this browser.');
      return null;
    }
     // Set the canvas size to match the video's current dimensions
     canvasElement.width = this.videoElement.videoWidth;
     canvasElement.height = this.videoElement.videoHeight;
  
    // Draw the current frame of the video onto the canvas
    context.drawImage(this.videoElement, 0, 0, canvasElement.width, canvasElement.height);
  }

  closeBox(){
    this.dialogRef.close();
  }
}
